import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker';
import logout from './../../Global/logout';
import formatDate from './../../Global/formatDate';

export default async function GetInvoices(
    activePage = 1, 
    pageSize = 10, 
    pickedPosProstor = {}, 
    pickedNapUred = {}, 
    startDate, 
    endDate = new Date(),
    sortDirection = true
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let queryData = "?page=" + activePage + "&size=" + pageSize

    if(sortDirection){
        queryData += '&sort_direction='
        queryData += 'DESC'
    }
    else{
        queryData += "&sort_direction=" 
        queryData += "ASC"
    }

    if(pickedPosProstor.uuid){
        queryData = queryData + "&premises_uuid=" + pickedPosProstor.uuid
    }

    if(pickedNapUred.uuid){
        queryData = queryData + "&invoice_billing_device_uuid=" + pickedNapUred.uuid
    }

    if(startDate instanceof Date){
        let formatedDate = await formatDate(startDate)
        queryData = queryData + "&start_date=" + formatedDate.toString()
    }

    if(endDate instanceof Date){
        let formatedDate = await formatDate(endDate)
        queryData = queryData + "&end_date=" + formatedDate.toString()
    }
    
    
    
    return await resolve(
        axios( 'client/invoices' + queryData, {
            method: 'get',
            headers: { 'Authorization' : unHashedJwt.data}           
        }).then(res => res.data)
        .catch(error => error.response.data)
        );
}